// eslint-disable-next-line import/prefer-default-export
export const FAVORITE_PROPOSAL_EVENT = {
  // Received after a click on the favorite icon
  OFFER_FAVORITE_TOGGLE: 'offer-favorite-toggle',
  // Received after a click on the proposal icon
  OFFER_PROPOSAL_TOGGLE: 'offer-proposal-toggle',
  // Received after a click on the refuse proposal icon
  OFFER_REFUSE_PROPOSAL_TOGGLE: 'offer-refuse-proposal-toggle',
  // Received after send match proposal form
  OFFER_SAVE_PROPOSAL: 'offer-save-proposal',
  // Received after a click on the favorite icon to update favorite data
  OFFER_FAVORITE_TOGGLE_CALLBACK: 'offer-favorite-toggle-callback',
  // Received after a click on the proposal icon to update proposal data
  OFFER_PROPOSAL_TOGGLE_CALLBACK: 'offer-proposal-toggle-callback',
  // Received after a click on the refuse proposal icon to update proposal data
  OFFER_REFUSE_PROPOSAL_TOGGLE_CALLBACK: 'offer-refuse-proposal-toggle-callback',
  // Received after a click on the favorite icon in take control on a seller user and cancel action
  CANCEL_PROPOSAL_ADDITION: 'cancel-proposal',
  // Received after a click on the proposal icon to add a new one
  OFFER_PROPOSAL_ADD: 'offer-proposal-add',
  // Received after a click on the proposal icon to remove one
  OFFER_PROPOSAL_REMOVE: 'offer-proposal-remove',
};

export const PROPOSAL_EVENT = {
  ADDED: 'proposal-added',
  REMOVED: 'proposal-removed',
};

export const USER_FAVORITE_ICON_ACTION = {
  // In take control match add an offer to user proposals
  PROPOSAL: 'proposal',
  // User add an offer to his favorites
  FAVORITE: 'favorite',
};
